export const IncidentsTileConsts = {
    cardTitle : 'Your incidents',
    trackIncidents : 'Track incidents',
    itemsRequiringActionFromYou: "Items requiring action from you",
    raiseIncident : 'Raise incident',
    activeIncidents: 'active incidents',
    viewClosedIncidents: 'View closed incidents',
    noIncidentsToView: 'No incidents to view',
    openIncidents: 'open incidents',
    actionRequired: 'Action required',
    errorMessage: 'There was an error loading this app.',
    servererror: 'Server error',
    loadingError: 'Loading error',
    tryAgain: 'Try again',
    trackOpenIncidents: 'Track open incidents'
}

